import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import axios from 'axios'

// Configure axios defaults based on environment
let apiBaseURL

// Check if we're on the production domain
const isProduction = window.location.hostname === 'cost.almar.food' || 
                    window.location.hostname === 'www.cost.almar.food'

if (isProduction) {
  // Production environment - use production API URL
  apiBaseURL = 'https://cost.almar.food/api'
  console.log('🚀 PRODUCTION MODE DETECTED')
} else {
  // Development environment - use relative URLs to work with Vue proxy
  apiBaseURL = ''
  console.log('🔧 DEVELOPMENT MODE DETECTED')
}

console.log('🌐 Setting API base URL:', { 
  hostname: window.location.hostname, 
  apiBaseURL,
  currentProtocol: window.location.protocol,
  currentHost: window.location.host
})

// Use environment variable if available, otherwise use calculated base URL
// Force empty baseURL for development to use Vue proxy
if (isProduction) {
  // Production environment - use the production API URL
  axios.defaults.baseURL = 'https://cost.almar.food/api'
  console.log('🔧 Axios configured for PRODUCTION:', axios.defaults.baseURL)
} else {
  // Development environment - use Vue proxy
  axios.defaults.baseURL = ''
  console.log('🔧 Axios configured for DEVELOPMENT (proxy):', axios.defaults.baseURL)
}
axios.defaults.timeout = 10000

// Add debug logging for API calls
console.log('🔧 Axios configuration:', {
  baseURL: axios.defaults.baseURL,
  timeout: axios.defaults.timeout,
  hasAuthHeader: !!axios.defaults.headers.common['Authorization']
})

// Test API configuration
if (isProduction) {
  console.log('🧪 Testing production API configuration...')
  // This will show the full URL that will be used
  console.log('📡 Example API call URL:', axios.defaults.baseURL + '/transactions')
}

// JWT request interceptor removed - no authentication required

const app = createApp(App)

// Register Element Plus icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// JWT token initialization removed - no authentication required

// JWT response interceptor removed - no authentication required

// JWT authentication cleanup function removed - no authentication required

// JWT authentication initialization removed - no authentication required

// Initialize Vue application
console.log('🚀 Initializing Vue application...')

// Global properties
app.config.globalProperties.$toast = toast

app.use(store)
   .use(router)
   .use(ElementPlus)
   .mount('#app')

console.log('🎉 Vue application mounted successfully!') 